import { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../AccountContext';
import { useCurrentBillingPeriod, useGetBillingPeriods } from '@app/sdk';
import EffectiveDateSelector from '../components/EffectiveDateSelector';

export default function CreateAdjustment() {
  const { accountId, transactionService, setError, billingDate } = useContext(AccountContext);
  const [amount, setAmount] = useState(0.0);
  const [direction, setDirection] = useState('Credit');
  const [originalTransactionId, setOriginalTransactionId] = useState<null | string>();
  const [description, setDescription] = useState('An Adjustment');
  const [reason, setReason] = useState('');
  const [creatingAdjustment, setCreatingAdjustment] = useState(false as boolean);
  const [effectiveDate, setEffectiveDate] = useState(billingDate as Date);
  const { data: billingPeriods } = useGetBillingPeriods(accountId);
  const { data: currentBillingPeriod } = useCurrentBillingPeriod(accountId);

  useEffect(() => {
    setEffectiveDate(billingDate);
  }, [billingDate]);

  const onAdjustmentClicked = async () => {
    try {
      setCreatingAdjustment(true);
      await transactionService.adjustment(accountId, direction, amount, description, reason, effectiveDate, originalTransactionId);
      setCreatingAdjustment(false);
    } catch (error) {
      setCreatingAdjustment(false);
      setError({ source: 'Create Adjustment', ...error });
    }
  };

  return (
    <div className="ui card">
      <div className="custom-card-header">Make an Adjustment</div>
      <div className="content">
        <div className="ui form">
          <div className="field">
            <label>Amount</label>
            <div className="ui labeled input">
              <div className="ui label">£</div>
              <input
                type="number"
                placeholder="Amount"
                step=".01"
                disabled={creatingAdjustment}
                onChange={(e) => setAmount(parseFloat(e.target.value))}
              />
            </div>
          </div>
          <div className="field">
            <label>Original Transaction Id</label>
            <input
              type="text"
              placeholder="00000000-0000-0000-0000-000000000000"
              value={originalTransactionId}
              disabled={creatingAdjustment}
              onChange={(e) => setOriginalTransactionId(e.target.value)}
            />
          </div>
          <div className="field">
            <label>Description</label>
            <input
              type="text"
              placeholder="Description"
              value={description}
              disabled={creatingAdjustment}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <EffectiveDateSelector
            baseDate={billingDate}
            effectiveDate={effectiveDate}
            onChange={setEffectiveDate}
            billingPeriods={billingPeriods}
            currentBillingPeriod={currentBillingPeriod}
            disabled={creatingAdjustment}
          />
          <div className="field">
            <div className="ui labeled input">
              <div className="ui label">Direction</div>
              <select onChange={(e) => setDirection(e.target.value)}>
                <option value="Credit">Credit</option>
                <option value="Debit">Debit</option>
              </select>
            </div>
          </div>
          <div className="field">
            <label>Reason</label>
            <input
              type="text"
              placeholder="Reason"
              value={reason}
              disabled={creatingAdjustment}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
        </div>
      </div>

      <button
        className={`ui primary button ${creatingAdjustment && 'loading'}`}
        type="submit"
        onClick={() => onAdjustmentClicked()}>
        Submit
      </button>
    </div>
  );
}
